import React, { useEffect, useState, useRef } from "react";
import axios from "../axios";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import noCoupons from "../img/other/no-coupon.png";

const EditFormQuestion = (props) => {
  // console.log(props);
  const boxRef = useRef();
  const { state } = useLocation();
  const EditEventId = state ? state.eventId : 0;
  const [Loader, setLoader] = useState(false);
  const [FormId, setFormId] = useState(0);
  const [QuestionName, setQuestionName] = useState('');
  const [QuestionStatus, setQuestionStatus] = useState(1);
  const [questionInputType, setquestionInputType] = useState('');
  const [LimitLengthCheck, setLimitLengthCheck] = useState(false);
  const [MinLength, setMinLength] = useState('');
  const [MaxLength, setMaxLength] = useState('');
  const [QuestionFormOption, setQuestionFormOption] = useState([]);
  const [FieldMapping, setFieldMapping] = useState('');

  const [QuestionNameError, setQuestionNameError] = useState('');
  const [MinLengthError, setMinLengthError] = useState('');
  const [MaxLengthError, setMaxLengthError] = useState('');

  const [ApplayTickets, setApplayTickets] = useState(1);
  const [AllTicktes, setAllTicktes] = useState('active');
  const [SelectedTicktes, setSelectedTicktes] = useState('');
  const [TicketsData, setTicketsData] = useState([]);
  const [ButtonDisable, setButtonDisable] = useState(false);
  const [SelectedTicketError, setSelectedTicketError] = useState('');

  const [HintType, setHintType] = useState(props.HintType !== '' ? props.HintType : 1);
  const [UploadHintfile, setUploadHintfile] = useState('');
  const [UploadedFileName, setUploadedFileName] = useState('');
  const [UploadfileError, setUploadfileError] = useState('');
  const [filedivFlag, setfiledivFlag] = useState(0);

  //---------- new added
  const [DateRangeYes, setDateRangeYes] = useState('');
  const [DateRangeNo, setDateRangeNo] = useState('active');
  const [DateRange, setDateRange] = useState(1);

  const [StartDate, setStartDate] = useState('');
  const [EndDate, setEndDate] = useState('');
  const [StartDateError, setStartDateError] = useState('');
  const [EndDateError, setEndDateError] = useState('');

  const [SpecificDomainYes, setSpecificDomainYes] = useState('');
  const [SpecificDomainNo, setSpecificDomainNo] = useState('active');
  const [SpecificDomain, setSpecificDomain] = useState(1);
  const [DomainName, setDomainName] = useState('');
  const [DomainNameError, setDomainNameError] = useState('');
  const [AllowValidation, setAllowValidation] = useState("0");
  const [PriceAddedFlag, setPriceAddedFlag] = useState(false);
  const [CountAddedFlag, setCountAddedFlag] = useState(false);
  const [AllowOtherAmtFlag, setAllowOtherAmtFlag] = useState(false);
  const [OptionsError, setOptionsError] = useState("");
  const [SortOrder, setSortOrder] = useState(0);
  const [preview, setPreview] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [HintDisplayImage, setHintDisplayImage] = useState("");

  // console.log(DomainName);
  const [MainQuestionHint, setMainQuestionHint] = useState(props.MainQuestionHint !== '' ? props.MainQuestionHint : '');
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setShowModal(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (props.TicketsDetails) {
      setTicketsData(props.TicketsDetails !== '' ? props.TicketsDetails : []);
    } else {
      setButtonDisable(true);
    }
  }, [props.TicketsDetails])

  useEffect(() => {
    const payload = {
      event_id: EditEventId,
      action_flag: 'form_quetion_edit',
      general_form_id: props.GeneralFormId ? props.GeneralFormId : 0,
      event_form_id: props.EventFormId ? props.EventFormId : 0,
    };
    axios.post("EventQuestionFormDetails", payload)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          const EditQuestionFormDetails = response.data.data.form_quetion_edit_details ? response.data.data.form_quetion_edit_details : [];
          // console.log(EditQuestionFormDetails);
          setFormId(EditQuestionFormDetails.form_id);
          setQuestionName(EditQuestionFormDetails.question_label);
          setQuestionStatus(EditQuestionFormDetails.is_manadatory);
          setAllowValidation(EditQuestionFormDetails.allow_validation);
          setquestionInputType(EditQuestionFormDetails.question_form_type);
          setLimitLengthCheck(EditQuestionFormDetails.limit_check === 1 ? true : false);
          setFieldMapping(EditQuestionFormDetails.user_field_mapping ? EditQuestionFormDetails.user_field_mapping : '');
          const LengthData = EditQuestionFormDetails.limit_length ? JSON.parse(EditQuestionFormDetails.limit_length) : "";
          setMinLength(LengthData.min_length ? LengthData.min_length : '');
          setMaxLength(LengthData.max_length ? LengthData.max_length : '');
          setSortOrder(EditQuestionFormDetails.sort_order ? EditQuestionFormDetails.sort_order : 0);

          setSpecificDomain(EditQuestionFormDetails.specific_domain); 
          setDomainName(EditQuestionFormDetails.domain_name ? EditQuestionFormDetails.domain_name : '');
          if(EditQuestionFormDetails.specific_domain === 2){
            setSpecificDomainYes('active'); setSpecificDomainNo('');
          }else{
            setSpecificDomainYes(''); setSpecificDomainNo('active'); 
          }

          setHintDisplayImage(EditQuestionFormDetails.hint_display_image ? EditQuestionFormDetails.hint_display_image : '');
          
          setDateRange(EditQuestionFormDetails.date_range); 
          if(EditQuestionFormDetails.date_range === 2){
            setDateRangeYes('active'); setDateRangeNo('');
          }else{
            setDateRangeYes(''); setDateRangeNo('active'); 
          }
          
          if(EditQuestionFormDetails.date_range === 2){
            setStartDate(EditQuestionFormDetails.range_start_date ? formatDateForInput(EditQuestionFormDetails.range_start_date) : '');
            setEndDate(EditQuestionFormDetails.range_end_date ? formatDateForInput(EditQuestionFormDetails.range_end_date) : '');
          }

          setHintType(EditQuestionFormDetails.hint_type ? EditQuestionFormDetails.hint_type : 1);
          setMainQuestionHint(EditQuestionFormDetails.question_hint ? EditQuestionFormDetails.question_hint : '');
          
          setApplayTickets(EditQuestionFormDetails.apply_ticket ? EditQuestionFormDetails.apply_ticket : 1);
          if(EditQuestionFormDetails.apply_ticket === 2){
            setAllTicktes(''); setSelectedTicktes('active');
          }else{
            setAllTicktes('active'); setSelectedTicktes('');
          }

          setPriceAddedFlag(EditQuestionFormDetails.question_price_flag === 1 ? true : false);
          setCountAddedFlag(EditQuestionFormDetails.question_count_flag === 1 ? true : false);
          setAllowOtherAmtFlag(EditQuestionFormDetails.question_other_amount_flag === 1 ? true : false);
          
          // if(EditQuestionFormDetails.question_form_type === "radio" || EditQuestionFormDetails.question_form_type === "select" || EditQuestionFormDetails.question_form_type === "checkbox"){
          //   const QueFormOption = EditQuestionFormDetails.question_form_option ? JSON.parse(EditQuestionFormDetails.question_form_option) : [];
          //   setQuestionFormOption(QueFormOption ? QueFormOption : []);
          // }
          if (
              EditQuestionFormDetails.question_form_type === "radio" ||
              EditQuestionFormDetails.question_form_type === "select" ||
              EditQuestionFormDetails.question_form_type === "checkbox"
            ) {
              let QueFormOption = EditQuestionFormDetails.question_form_option
                ? JSON.parse(EditQuestionFormDetails.question_form_option)
                : [];

              // Add one empty row
              QueFormOption.push({
                id: "",
                label: "",
              });

              setQuestionFormOption(QueFormOption);
            }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [])
  // console.log(QuestionFormOption);
 
  const formatDateForInput = (timestamp) => {
    const date = new Date(timestamp * 1000);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const handleTicketChange = (index, evnt) => {
    let TicketArray = [...TicketsData];
    TicketArray[index]['checked'] = evnt.target.checked;
    setTicketsData(TicketArray);
  }

  const handleValidation = () => {

    var flag = true;

    if (QuestionName === "") {
      setQuestionNameError("Please enter question name");
      flag = false;
    } else {
      setQuestionNameError("");
    }

    if (LimitLengthCheck === true) {
      if (MinLength === "") {
        setMinLengthError("Please enter min value");
        flag = false;
      } else {
        setMinLengthError("");
      }

      if (MaxLength === "") {
        setMaxLengthError("Please enter max value");
        flag = false;
      } else {
        setMaxLengthError("");
      }
    } else { setMinLengthError(""); setMaxLengthError(""); }

    var error_cat_flag = 0;
    if (ApplayTickets === 2) {
      for (var j = 0; j < TicketsData.length; j++) {
        if (TicketsData[j]['checked'] === true) {
          error_cat_flag = 1;
        }
      }

      if (error_cat_flag === 0) {
        setSelectedTicketError("Please select at least one ticket");
        flag = false;
      } else {
        setSelectedTicketError("");
      }
    } else {
      setSelectedTicketError("");
    }

    //--------- new added
    if (HintType === '2' || HintType === 2) {

      const fileExtension = UploadHintfile ? UploadHintfile.name.split(".").at(-1) : '';
      const allowedFileTypes = ["jpg", "jpeg", "png"];

      if (UploadHintfile !== '') {
        // console.log('ss');
        if (!allowedFileTypes.includes(fileExtension)) {
          setUploadfileError("File does not support. You must use jpg, jpeg, png");
          setfiledivFlag(1)
          flag = false;
        } else if (UploadHintfile.size > 2e6) {
          setUploadfileError("Please upload a file smaller than 2 MB");
          setfiledivFlag(1)
          flag = false;
        } else {
          setUploadfileError("");
          setfiledivFlag(0)
        }
      }
    } else {
      setUploadfileError("");
      setfiledivFlag(0)
    }

    //----------- date range 
    if (DateRange === '2' || DateRange === 2) {
      if (StartDate === "") {
        setStartDateError("Please enter start date");
        flag = false;
      } else {
        setStartDateError("");
      }

      if (EndDate === "") {
        setEndDateError("Please enter end date");
        flag = false;
      } else {
        setEndDateError("");
      }
    }

    //----------- specifics domain name
    if (SpecificDomain === '2' || SpecificDomain === 2) {
      if (DomainName === "") {
        setDomainNameError("Please domain name");
        flag = false;
      } else {
        setDomainNameError("");
      }
    }

    return flag;
  };

  const handleSubmit = (e) => {

    e.preventDefault();
    const flag = handleValidation();
    if (flag) {
      setLoader(true);

      const formData = new FormData();
      formData.append("event_id", EditEventId ? EditEventId : 0);
      formData.append("general_form_id", props.GeneralFormId ? props.GeneralFormId : 0);
      formData.append("event_form_id", props.EventFormId ? props.EventFormId : 0);
      formData.append("form_id", FormId);
      formData.append("question_form_type", questionInputType);
      formData.append("question_name", QuestionName);
      formData.append("question_mandatory_status", QuestionStatus);
      formData.append("question_form_options", QuestionFormOption ? JSON.stringify(QuestionFormOption) : []);
      formData.append("limit_length_check", LimitLengthCheck);
      formData.append("min_length", MinLength);
      formData.append("max_length", MaxLength);
      formData.append("allow_validation", AllowValidation);
      formData.append("specific_domain", SpecificDomain);
      formData.append("domain_name", DomainName);
      formData.append("date_range", DateRange);
      formData.append("range_start_date", StartDate);
      formData.append("range_end_date", EndDate);
      formData.append("hint_type", HintType);
      formData.append("main_question_hint", MainQuestionHint);
      formData.append("upload_hint_file", UploadHintfile);
      formData.append("upload_file_name", UploadedFileName);
      formData.append("apply_ticket", ApplayTickets);
      formData.append("field_mapping", FieldMapping);
      formData.append("sort_order", SortOrder);
      formData.append("ticket_selected_data", TicketsData ? JSON.stringify(TicketsData) : []);
      formData.append("question_price_flag", PriceAddedFlag === true ? 1 : 0);
      formData.append("question_count_flag", CountAddedFlag === true ? 1 : 0);
      formData.append("question_other_amount_flag", AllowOtherAmtFlag === true ? 1 : 0);

      axios.post("EditEventFormQuestions", formData)
        .then((response) => {
          setLoader(false);
          // console.log(response);
          if (response.status === 200) {
            props.setEditFormQuestionFlag(false);
            props.setEventFlag(true);
            toast.success(response.data.message)
          }
        })
        .catch(() => {
          setLoader(false);
          console.log('error');
        });
    }
  };

  useEffect(() => {
    if (questionInputType === 'radio' || questionInputType === 'select' || questionInputType === 'checkbox') {
      if (QuestionFormOption.length > 0) {
        const last = QuestionFormOption[QuestionFormOption.length - 1];

        if (last.label !== "") {
          setQuestionFormOption([
            ...QuestionFormOption,
            // { id: Date.now(), label: "" }
            {id: Date.now(), label: '', price: '', count: '' }
          ]);
        }
      }
    }
  }, []);

  // const addRow = () => {
  //   const lastRow = QuestionFormOption[QuestionFormOption.length - 1];
  //   console.log(lastRow);
  //   // if (!lastRow || lastRow.label.trim() === "") return;
  //   if (!lastRow?.label || lastRow.label.trim() === "") {
  //     alert("Please enter option");
  //     return;
  //   }
  //   // ✅ add new empty row
  //   setQuestionFormOption((prev) => [
  //     ...prev,
  //     // { id: Date.now(), label: ""}
  //     {id: Date.now(), label: '', price: '', count: '' }
  //   ]);
  // };

  const addRow = () => {
    setQuestionFormOption((prev) => {
      const lastRow = prev[prev.length - 1];

      if (!lastRow?.label || lastRow.label.trim() === "") {
        // alert("Please enter option");
        setOptionsError("Please enter option");
        return prev; 
      }
      setOptionsError("");
      return [
        ...prev,
        { id: Date.now(), label: "", price: "", count: "" }
      ];
    });
  };

  const removeRow = (id) => {
    setQuestionFormOption(QuestionFormOption.filter(row => row.id !== id));
  };

  const handleInputChange = (id, column, value) => {
    // console.log(id, column, value);
    setQuestionFormOption((prev) =>
      prev.map((row) => {
        if (row.id === id) {
          return { ...row, [column]: value };
        }
        return row;
      })
    );

    if (column === "label") {
      if (!value.trim()) {
        setOptionsError("Please enter option");
      } else {
        setOptionsError("");
      }
    }
  };

  const uplodFile = (e) => {
    let file = e.target.files[0];
    if (file) {
      setUploadHintfile(file);
      setUploadedFileName(file.name);
      setPreview(URL.createObjectURL(file)); // create preview
    }
  };

  // console.log(QuestionFormOption);
  const questionHintCheck = (e) => {
    // console.log(e.target.value);
    const Type = e.target.value;
    if (Type === '1' || Type === 1) {
      setMainQuestionHint("");
    } else {
      setMainQuestionHint(props.MainQuestionHint !== '' ? props.MainQuestionHint : '');
    }
  }

  const visibleOptions = QuestionFormOption.filter(
  (item) => item.label !== "Other Amount"
);

const imageSrc = preview || HintDisplayImage;

  return (
    <>

<div className="modal is-visible w-100" data-animation="slideInUp" >
  <div className="modal-dialog quickview__main--wrapper">

    <form method="post" onSubmit={handleSubmit} encType="multipart/form-data" >
      <div className="quickview__inner">
        <div className="row">

          <div className="login__section">
            <div className="login__section--inner" >
              <div className="p-5">
                <div className="account__login--header mb-25">
                  <h3 className="account__login--header__title mb-10">Edit Questions Details</h3>
                  <hr />
                </div>

  <div className="row">
    
    <div className="col-sm-12">
      <div className="form-floating mb-0">
        <input
          type="text"
          className="form-control"
          placeholder=""
          value={QuestionName}
          onChange={(e) => { setQuestionName(e.target.value); }}
          disabled={(FormId !== 999999 || QuestionName === "Other Amount") ? true : false}
        />
        <label>Question Name<span className="checkout__input--label__star">*</span></label>
        <small className="text-danger">{QuestionNameError}</small>
      </div>
    </div>

    <div className="col-sm-12 mt-4">
      <div className="form-floating">
      <select className="form-control" name="filed_mapping" value={FieldMapping}  onChange={(e) => { setFieldMapping(e.target.value); }}> 
        <option value="">-- Select --</option>
          { (props.FieldMappingData && props.FieldMappingData.length > 0) ?
                props.FieldMappingData.map((item,index) => {
                  return (
                    <option value={item.COLUMN_NAME} key={index}>{item.COLUMN_NAME}</option>
                  )
              }) : null
          }
        </select>
        <label className="form-check-label">Field Mapping</label>
      </div>
    </div>

    { questionInputType === 'checkbox' || questionInputType === 'select' || questionInputType === 'radio' ? 
      <>
        <div className="row align-items-center my-3 mt-4">
          <div className="col-sm-4">
            <div className="form-check form-switch d-flex align-items-center">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                value={PriceAddedFlag} onChange={(e) => { setPriceAddedFlag(!PriceAddedFlag) }}
                checked={PriceAddedFlag}
              />
              <label className="form-check-label">Price</label>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-check form-switch d-flex align-items-center">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                value={CountAddedFlag} onChange={(e) => { setCountAddedFlag(!CountAddedFlag) }}
                checked={CountAddedFlag}
              />
              <label className="form-check-label">Maximum Count Limit</label>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-check form-switch d-flex align-items-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  value={AllowOtherAmtFlag} onChange={(e) => { setAllowOtherAmtFlag(!AllowOtherAmtFlag) }}
                  checked={AllowOtherAmtFlag}
                />
              <label className="form-check-label">Allow Other Amount</label>
            </div>
          </div>
        </div>

        <table className="ch-box">
          <thead>
            <tr className="ch-header">
              <th className="text-center py-2">Options</th>
              {PriceAddedFlag === true ?
                <th className="text-center py-2">Price</th>
              : null }
              
              {CountAddedFlag === true ?
                <th className="text-center py-2">Count</th>
              : null }
              <th className="text-center p-3">Action</th>
            </tr>
          </thead>
        <tbody>
          
        {visibleOptions.map((row, index) => {

              const isLast = index === visibleOptions.length - 1;

              return (
                <tr key={row.id}>
                  <td>
                      <input
                        type="text"
                        value={row.label}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleInputChange(row.id, "label", value);
                          if (
                            isLast &&
                            value.trim() !== "" &&
                            QuestionFormOption[QuestionFormOption.length - 1].label === ""
                          ) {
                            addRow();
                          }
                        }}
                      />
                     
                      {!row.label.trim() && OptionsError && (
                        <small className="text-danger" style={{display: "grid"}}>{OptionsError}</small>
                      )}
                  </td>

                  {PriceAddedFlag && (
                    <td>
                      <input
                        type="text"
                        value={row.price || ""}
                        onChange={(e) =>
                          handleInputChange(row.id, "price", e.target.value)
                        }
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                        }}
                        maxLength={6}
                      />
                    </td>
                  )}

                  {CountAddedFlag && (
                    <td>
                      <input
                        type="text"
                        value={row.count || ""}
                        onChange={(e) =>
                          handleInputChange(row.id, "count", e.target.value.replace(/\D/g, ""))
                        }
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                        }}
                        maxLength={5}
                      />
                    </td>
                  )}

                  <td>
                    {isLast ? (
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 -960 960 960"
                          width="24"
                          onClick={() => addRow()}
                          style={{ cursor: "pointer", marginTop: "14px" }}
                        >
                          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                      </svg>
                    ) : (
                      // 🗑 DELETE
                      visibleOptions.length > 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" height={20} viewBox="0 -960 960 960" width={20} onClick={() => removeRow(row.id)} >
                          <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
                        </svg>
                      )
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {AllowOtherAmtFlag === true ?
          <div className="aoa mt-2">
            <div className="card px-4 py-3">
              <div className="row align-items-center">
              <div className="col-sm-4">
                <label>Other Amount</label>
              </div>
              <div className="col-sm-8">
                <input type="text" className="form-control" placeholder="Other Amount" readOnly/>
              </div>
            </div>
            </div>
          </div>
        : null }
      </>
    : null }
     
      <div className="col-sm-6 mt-4">
        <div className="form-floating ">
          <select className="form-control" name="question_type" value={QuestionStatus} onChange={(e) => { setQuestionStatus(e.target.value); }}>
            <option value="0">Optional</option>
            <option value="1">Mandatory</option>
          </select>
          <label>Question Status<span className="checkout__input--label__star">*</span></label>
        </div>
      </div>

      <div className="col-sm-6 mt-4">
        <div className="form-floating ">
          <select className="form-control" name="question_type" value={AllowValidation} onChange={(e) => { setAllowValidation(e.target.value); }}>
            <option value="0">Both</option>
            <option value="1">Digit</option>
            <option value="2">Character</option>
          </select>
          <label>Allow Validation<span className="checkout__input--label__star">*</span></label>
        </div>
      </div>
   

    {questionInputType == 'text' || questionInputType == 'mobile' || questionInputType == 'amount' || questionInputType == 'textarea' ?
      <div className="row align-items-center mt-2">
        <div className="col-sm-4">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              value={LimitLengthCheck} onChange={(e) => { setLimitLengthCheck(!LimitLengthCheck) }}
              checked={LimitLengthCheck}
            />
            <label className="form-check-label">Limit Length </label>
          </div>
        </div>

        <div className={LimitLengthCheck === true ? 'col-sm-4' : 'col-sm-4 invisible'}>
          <div className="form-floating mt-3 mb-0">
            <input className="form-control" placeholder="Min Length" type="text"
              name="min_length" value={MinLength} maxLength={5} autoComplete="off" onChange={(e) => {
              const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setMinLength(value);
                }
              }} />
            <label>Min Length<span className="checkout__input--label__star">*</span></label>
            <small className="text-danger">{MinLengthError}</small>
          </div>
        </div>

        <div className={LimitLengthCheck === true ? 'col-sm-4' : 'col-sm-4 invisible'}>
          <div className="form-floating mt-3 mb-0">
            <input className="form-control" placeholder="Max Length" type="text"
              name="max_length" value={MaxLength} maxLength={5} autoComplete="off" onChange={(e) => {
              const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setMaxLength(value);
                }
              }}/>
            <label>Max Length<span className="checkout__input--label__star">*</span></label>
            <small className="text-danger">{MaxLengthError}</small>
          </div>
        </div>
      </div>
    : ''}

    {questionInputType === "email" ?
      <>
        <div className="section__header checkout__section--header d-flex align-items-center mt-4 gap-3">
          <label>Apply For Specific Domain</label>
          <div className="ebi">
            <div className="event-visibility hand_cursor">

              <div className={'visibility gap-1 ' + SpecificDomainNo} onClick={() => { setSpecificDomain(1); setSpecificDomainYes(''); setSpecificDomainNo('active'); }} >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                </svg>
                No
              </div>

              <div className={'visibility gap-1 ' + SpecificDomainYes} onClick={() => { setSpecificDomain(2); setSpecificDomainYes('active'); setSpecificDomainNo(''); }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z" />
                </svg>
                Yes
              </div>

            </div>
          </div>
        </div>

        {SpecificDomain === 2 ?
          <div className="col-sm-12 mt-3">
            <div className="form-floating mb-0">
              <input
                type="text"
                className="form-control"
                placeholder=""
                value={DomainName}
                onChange={(e) => { setDomainName(e.target.value); }}
              />
              <label>Domain Name</label>
              <small className="text-danger">{DomainNameError}</small>
            </div>
          </div>
          : null}
    
      </>
      : ''
    }

    {questionInputType === "date" ?
      <div>

        <div className="section__header checkout__section--header d-flex align-items-center mt-4 gap-3">
          <label>Date Range</label>
          <div className="ebi">
            <div className="event-visibility hand_cursor">

              <div className={'visibility gap-1 ' + DateRangeNo} onClick={() => { setDateRange(1); setDateRangeYes(''); setDateRangeNo('active'); }} >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                </svg>
                No
              </div>

              <div className={'visibility gap-1 ' + DateRangeYes} onClick={() => { setDateRange(2); setDateRangeYes('active'); setDateRangeNo(''); }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z" />
                </svg>
                Yes
              </div>

            </div>
          </div>
        </div>

        {DateRange === 2 ?
          <div className="row">
            <div className="col-sm-6 mt-4">
              <div className="form-floating mb-0">
                <input
                  type="date"
                  className="form-control"
                  placeholder=""
                  value={StartDate}
                  onChange={(e) => { setStartDate(e.target.value); setEndDate(''); }}
                />
                <label>Start Date</label>
                <small className="text-danger">{StartDateError}</small>
              </div>
            </div>

            <div className="col-sm-6 mt-4">
              <div className="form-floating mb-0">
                <input
                  type="date"
                  className="form-control"
                  placeholder=""
                  value={EndDate}
                  onChange={(e) => { setEndDate(e.target.value); }}
                  min={StartDate ? new Date(StartDate).toISOString().split("T")[0] : new Date().toISOString().split('T')[0]}
                />
                <label>End Date</label>
                <small className="text-danger">{EndDateError}</small>
              </div>
            </div>
          </div>
          : null}
      </div>
      : ''
    } 

    {/* <div className="row mt-4 mb-4"> */}
      <div className="col-sm-4 mt-4 mb-4">
        <div className="form-floating ">
          <select className="form-control" name="question_type" value={HintType} onChange={(e) => { setHintType(e.target.value); setUploadfileError(""); questionHintCheck(e); setPreview(""); }}>
            <option value="1">Text</option>
            <option value="2">Image</option>
          </select>
          <label>Hint Type<span className="checkout__input--label__star">*</span></label>
        </div>
      </div>

      {HintType === 1 || HintType === '1' ?
        <>
          <div className="col-sm-8 mt-4 mb-4">
            <div className="form-floating mb-0">
              <input
                type="text"
                className="form-control"
                placeholder=""
                value={MainQuestionHint} 
                onChange={(e) => { setMainQuestionHint(e.target.value); setPreview(""); }}
              />
              <label>Question Hint</label>
            </div>
          </div>
        </>
      :
        <>
          <div className="col-sm-6 mt-4 mb-4">
            <div className="form-floating mb-0">
              <input type="file" className="form-control" onChange={uplodFile} />
              <label>Question Hint (Image)</label>
            </div>
            <small className="text-danger">{UploadfileError}</small>
          </div>
          <div className="col-sm-2 mt-4 mb-4">
    
            {imageSrc && (
              <img
                src={imageSrc}
                alt="preview"
                style={{ width: "auto", height: "auto", cursor: "pointer" }}
                onClick={() => setShowModal(true)}
              />
            )}
            
          </div>

          {showModal && (
              <div 
                ref={boxRef}
                onClick={() => setShowModal(false)} 
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.8)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <img 
                  src={imageSrc} 
                  alt="full" 
                  style={{ maxWidth: "100%", maxHeight: "100%" }} 
                />
              </div>
          )}
        </>
      }

    {/* </div> */}
   
    {QuestionName !== "Other Amount" ?
      <>
        <hr />
        <div className="section__header checkout__section--header d-flex align-items-center justify-content-between mt-4 mb-4">
          
          {/* <label>Applay Tickets</label> */}
          <div className="ebi">
            <div className="event-visibility hand_cursor">
              <div className={'visibility gap-1 ' + AllTicktes} onClick={() => { setApplayTickets(1); setAllTicktes('active'); setSelectedTicktes(''); }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z" />
                </svg>
                All Tickets
              </div>

              <div className={'visibility gap-1 ' + SelectedTicktes} onClick={() => { setApplayTickets(2); setAllTicktes(''); setSelectedTicktes('active'); }} >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={20}
                  viewBox="0 -960 960 960"
                  width={20}
                >
                  <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                </svg>
                Selected Tickets
              </div>

            </div>
          </div>
        
        </div>
      </>
    : null }  
    
    
    <div className="row">
      {TicketsData && TicketsData.length > 0 ?
        TicketsData.map((item, index) => (
          <>
            {ApplayTickets === 2 ?
              <div className="col-sm-6 my-3" key={index + '11'}>
                <div className="plans">
                  <label className="plan basic-plan">
                    <input name="1"
                      type="checkbox"
                      className="btn-check"
                      value={item.checked}
                      defaultChecked={item.checked}
                      onClick={(evnt) => { handleTicketChange(index, evnt); }}
                    />
                    <div className="plan-content">
                      <div className="plan-details" for='btn-check-outlined-1'>
                        <span className="h3 m-0"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm0-160q17 0 28.5-11.5T520-480q0-17-11.5-28.5T480-520q-17 0-28.5 11.5T440-480q0 17 11.5 28.5T480-440Zm0-160q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm320 440H160q-33 0-56.5-23.5T80-240v-160q33 0 56.5-23.5T160-480q0-33-23.5-56.5T80-560v-160q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v160q-33 0-56.5 23.5T800-480q0 33 23.5 56.5T880-400v160q0 33-23.5 56.5T800-160Zm0-80v-102q-37-22-58.5-58.5T720-480q0-43 21.5-79.5T800-618v-102H160v102q37 22 58.5 58.5T240-480q0 43-21.5 79.5T160-342v102h640ZM480-480Z" /></svg> {item.ticket_name}</span>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              : null}
          </>
        ))
        :

        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 py-5 my-2 pb-0" >
          <div className="w-100 not-avilable-card p-3 pb-4 d-flex flex-column align-items-center">
            <img className="" src={`${noCoupons}`} alt="" style={{ width: "130px" }} />
            <p className="section__header--title h4 mb-3">No tickets avilable</p>
            <p className="mb-4">No ticket to apply discounts. Please create an available tickets first</p>
          </div>
        </div>
      }

      <small className="text-danger">{SelectedTicketError}</small>
      
    </div>

    <div className="d-flex gap-4">
      <button className="account__login--btn secondary__btn mt-2" onClick={() => { props.setEditFormQuestionFlag(false); }}>Close</button>

      <input type="submit" name="command" value="Save" className="account__login--btn primary__btn mt-2" disabled={ButtonDisable === true ? true : false} />

    </div>

  </div>

              </div>
            </div>


          </div>
        </div>
      </div>
    </form>
  </div>
</div>

    </>
  );
};

export default EditFormQuestion;
